<template>
  <div ref="scroller" class="tva-scroller">
    <slot></slot>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    threshold: {
      type: Number,
      default: 0.5
    },
    top: {
      type: Number,
      default: 0.5
    },
    bottom: {
      type: Number,
      default: 0.3
    },
    fixedTop: {
      type: String,
      default: "0"
    },
    snap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: 0,
      offset: 0,
      progress: -1,
      activeSections: [],
      delayedOffset: 0,
      delayedProgress: 0
    };
  },
  computed: {
    _treshold() {
      return window.innerHeight * this.threshold;
    },
    _top() {
      return window.innerHeight * this.top;
    },
    _bottom() {
      return window.innerHeight * this.bottom;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // Find foreground
      const foreground = this.$slots.default.filter(
        s => s.data.ref === "foreground"
      )[0].elm;

      // Find background
      const filter = this.$slots.default.filter(
        s => s.data.ref === "background"
      )[0];
      const background = filter ? filter.elm : null;

      // Find sections
      const sections = foreground.childNodes;

      // Scroll listener
      window.addEventListener("scroll", () => {
        let activeSections = [];

        let foregroundTop = foreground.getBoundingClientRect().top;
        let computedForegroundTop = foregroundTop - this._treshold;
        let foregroundHeight = foreground.getBoundingClientRect().height;

        let progress = -computedForegroundTop / foregroundHeight;

        this.$emit("progress", { value: progress });
        this.progress = progress;

        // Pin background
        if (background) {
          if (
            foregroundTop < this._top &&
            -foregroundTop + this._bottom < foregroundHeight
          ) {
            // Fixed
            background.style.position = "fixed";
            background.style.top = this.fixedTop;
            background.style.bottom = "auto";
            background.style.left = 0;
          } else if (foregroundTop >= this._top) {
            // Not fixed top
            background.style.position = "absolute";
            background.style.top = 0;
            background.style.bottom = "auto";
            background.style.left = 0;
          } else if (-foregroundTop + this._bottom >= foregroundHeight) {
            // Not fixed bottom
            background.style.position = "absolute";
            background.style.top = "auto";
            background.style.bottom = 0;
            background.style.left = 0;
          }
        }

        _.forEach(sections, (section, index) => {
          let top = section.getBoundingClientRect().top - this._treshold;
          let height = section.getBoundingClientRect().height;

          let offset = -top / height;

          if (offset >= 0 && offset <= 1) {
            this.offset = offset;
            this.index = index;
            this.$emit("offset", { value: offset });
            this.$emit("index", { value: index });
          }

          // list of section in viewport
          if (
            section.getBoundingClientRect().top <
              window.innerHeight * this.bottom &&
            section.getBoundingClientRect().bottom >
              window.innerHeight * this.top
          ) {
            activeSections.push(index);

            this.$emit("activeSections", { value: activeSections });
          }
        });
      });
    });
    this.computeProgress();
  },
  watch: {
    progress(progress, oldProgress) {
      if (progress >= 0 && oldProgress >= 0) {
        this.$emit("direction", {
          value: progress > oldProgress ? "foreward" : "backward"
        });
      }
    },
    index: _.debounce(function() {
      if (this.snap) this.$scrollTo(`#scroller-section-${this.index - 1}`, 500);
    }, 1000)
  },
  methods: {
    computeProgress() {
      setInterval(() => {
        let tempOffset = this.offset - this.delayedOffset;
        this.delayedOffset += tempOffset / 10;
        this.$emit("delayedOffset", { value: this.delayedOffset });

        let tempProgress = this.progress - this.delayedProgress;
        this.delayedProgress += tempProgress / 10;
        this.$emit("delayedProgress", { value: this.delayedProgress });
      }, 50);
    }
  }
};
</script>

<style scoped>
.tva-scroller {
  position: relative;
}
</style>
